import io from 'socket.io-client';

// LA CONNEXIÓ EN VIU.
//
// El que hi havia era canonada per a una col·laboració que no existia: `sendModelUpdate`,
// `sendCursorMove` i `sendSimulationUpdate` no els cridava ningú, i els gestors del servidor
// reenviaven a una sala on **el socket ni tan sols demanava identificar-se**.
//
// Des del 27/08/2026 el servidor exigeix el testimoni i comprova que puguis veure el model abans
// de deixar-te entrar a la seva sala. Aquí queda **només el que es fa servir**: qui hi ha, qui té
// el llapis, i prendre'l.
class SocketService {
  constructor() {
    this.socket = null;
  }

  connect() {
    const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:3001';
    this.socket = io(WS_URL, {
      transports: ['websocket'],
      auth: { token: localStorage.getItem('token') },
    });
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  joinModel(modelId) { this.socket?.emit('join-model', modelId); }
  leaveModel(modelId) { this.socket?.emit('leave-model', modelId); }
  prenLlapis(modelId) { this.socket?.emit('pren-llapis', modelId); }
  heDesat(modelId) { this.socket?.emit('he-desat', modelId); }

  // Qui hi és i qui té el llapis. Arriba a cada canvi de la sala.
  onSala(cb) { this.socket?.on('sala', cb); }
  // Te l'han pres: arriba només a qui el tenia.
  onLlapisPres(cb) { this.socket?.on('llapis-pres', cb); }
  // Algú altre ha desat: val la pena tornar a carregar.
  onDesatPerAlgu(cb) { this.socket?.on('desat-per-algu', cb); }
}

const socketService = new SocketService();
export default socketService;
